// Modules
import React from 'react';
import slugify from 'react-slugify';
import Head from 'next/head';

// Types
import { ICatalog } from 'src/common/types/CatalogType';

//BrandContent
import content from 'src/common/content';

// Services
import catalogService from 'src/services/catalogService';
import { CatalogProvider } from 'src/contexts/Catalog';

// Components
import { CatalogPage } from 'src/components/templates/CatalogPage';
interface IParams {
  uf: string;
}
interface INavigationPage {
  data: ICatalog;
}

const UfCatalogPage = ({ data }: INavigationPage) => {
  return (
    <>
      <Head>
        <title>{`${content.platform} Digital - ${content.name}`}</title>
        <meta
          name="description"
          content={`Confira os principais destaques, lançamentos e promoções de ${content.name} no ciclo ${data.cycle.number} com o nosso ${content.platform} Digital!`}
        />
        <meta name="robots" content="noindex" />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no"
        />
      </Head>
      <CatalogProvider catalogData={data}>
        <CatalogPage />
      </CatalogProvider>
    </>
  );
};

export async function getStaticPaths() {
  const paths = content.states.map((uf) => {
    return {
      params: {
        uf: slugify(uf),
      },
    };
  });
  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }: { params: IParams }) {
  const res = await catalogService.getCatalog(
    params.uf.toUpperCase() || process.env.DEFAULT_STATE,
  );

  return {
    props: {
      uf: params.uf.toUpperCase(),
      data: res,
    },
  };
}

export default UfCatalogPage;
